import { StringMap } from 'i18next'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Wrapper,
  ContentWrapper,
  ApiApprovedWrapper,
  Title,
  Description,
  Image,
  SmallText,
} from './TopPart.styled'
import { Button, Tooltip } from '@clickcease/cc-client-components-lib'
import crossSellBmImage from 'Assets/images/crossSellBM.webp'
import crossSellPmImage from 'Assets/images/crossSellPM.webp'
import { useNavigate } from 'react-router-dom'
import { ApiApproved } from 'Assets/images/apiApproved'
import { PRODUCT_TYPES, I18N_PLATFORMS_NAME } from 'Types/ProductTypes'

const { PAID_MARKETING, BOT_ZAPPING } = PRODUCT_TYPES

// BM = Bot Mitigation
export const TopPart = ({ BM }: { BM?: boolean }) => {
  const { t } = useTranslation('pricing')
  const navigate = useNavigate()
  const contentRef = useRef<HTMLDivElement>(null)

  const platform = BM ? I18N_PLATFORMS_NAME[BOT_ZAPPING] : I18N_PLATFORMS_NAME[PAID_MARKETING]

  const translate = (key: string, options?: StringMap) =>
    t(`cross-sell.${platform}.${key}`, options)

  const handleClick = () =>
    navigate('/cross-sell-pricing', {
      state: {
        selectedTab: BM ? 1 : 0,
      },
    })

  const imageStyle = {
    maxHeight: contentRef.current ? `${contentRef.current?.clientHeight}px` : 'unset',
  }

  return (
    <Wrapper>
      <ContentWrapper ref={contentRef}>
        <Title>{translate('title')}</Title>
        <Description>{translate('description')}</Description>
        <Button text={translate('cta_btn')} size="md" onClick={handleClick} />
        {BM && (
          <>
            <SmallText quick_setup>{translate('quick_setup')}</SmallText>
            <SmallText disclaimer>{translate('disclaimer')}</SmallText>
          </>
        )}
        {!BM && (
          <ApiApprovedWrapper>
            <ApiApproved />
            <Tooltip tooltiptContent={translate('api_approved_tooltip')} />
          </ApiApprovedWrapper>
        )}
      </ContentWrapper>
      <Image src={BM ? crossSellBmImage : crossSellPmImage} style={imageStyle} />
    </Wrapper>
  )
}
